import { render } from "./Sidenav.vue?vue&type=template&id=b3e7099e&lang=pug"
import script from "./Sidenav.vue?vue&type=script&lang=js"
export * from "./Sidenav.vue?vue&type=script&lang=js"

import "./Sidenav.vue?vue&type=style&index=0&id=b3e7099e&lang=scss"

import exportComponent from "/home/apognu/code/personal/defcon/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__